/** Hora del servidor en ISO, leída del header `Date` de la API REST de Supabase.
 *  Si no hay red o el header no está disponible, devuelve el reloj del dispositivo
 *  (en ese caso `hora_sospechosa` simplemente no se dispara). */
export async function fetchServerNowIso(): Promise<string> {
  const deviceNow = () => new Date().toISOString();
  try {
    const res = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/rest/v1/`, {
      method: 'HEAD',
      headers: { apikey: import.meta.env.VITE_SUPABASE_ANON_KEY },
    });
    const header = res.headers.get('date');
    if (!header) return deviceNow();
    const parsed = new Date(header);
    if (Number.isNaN(parsed.getTime())) return deviceNow();
    return parsed.toISOString();
  } catch {
    return deviceNow();
  }
}
